import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { fetchAIFadvPackageTableAndFilterSchema } from "model/AIFadvPackageModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const AIFadvPackageContext = createContext();

export const AIFadvPackageProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aiFadvPackageContextData, setAIFadvPackageContextData] = useState();
  const [aiFadvPackageVersion, setAIFadvPackageVersion] = useState();

  const fetchAIFadvPackageContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:aiFadvPackage", () =>
        fetchAIFadvPackageTableAndFilterSchema([])
      );
      if (response?.success) {
        setAIFadvPackageContextData(response?.data);
        setAIFadvPackageVersion(response?.schemaVersion);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <AIFadvPackageContext.Provider
      value={{
        fetchAIFadvPackageContextData,
        aiFadvPackageContextData,
        loading,
        error,
        aiFadvPackageVersion,
      }}
    >
      {children}
    </AIFadvPackageContext.Provider>
  );
};

export const useAIFadvPackageContext = () => useContext(AIFadvPackageContext);
